import _ from 'lodash';

import { CIC_DATE_TIME_FORMAT, CIC_EMPTY_DISPLAY_VALUE } from 'constants/cicReason';
import { CENTRAL_TIME_ZONE } from 'constants/date';
import { formatDate } from 'utils/date';
import { getPersonInitials } from 'utils/loanApplication';

/** CIC reason times are UTC instants; the loan team reads them in Central time. */
export const formatCicDateTime = date =>
  _.isNil(date) ? '' : formatDate(date, CIC_DATE_TIME_FORMAT, { timeZone: CENTRAL_TIME_ZONE });

export const getCicDisplayValue = value =>
  _.isNil(value) || value === '' ? CIC_EMPTY_DISPLAY_VALUE : value;

export const getCicAuthorInitials = name => getPersonInitials({ firstName: name ?? '' });

export const getReasonsForFee = (reasons, feeTypeId) =>
  reasons.filter(({ isActive, items }) => isActive !== false && _.some(items, { feeTypeId }));
